import React, { useEffect, useState, Suspense, lazy } from "react";
import underlineimage from "../assets/images/title-shape.png";
import bg from "../assets/images/Homepagesec/blogsec.png";
import { fetchBlogList } from "../api/blogApi";
import RoundLoader from "../common/RoundLoader";
import { useTranslation } from "react-i18next";
import type { Blog } from "@gtypes/blog"; // alias used

const BlogCard = lazy(() => import("./BlogCard"));

const Blogs: React.FC = () => {
  const { t } = useTranslation();
  const [blogData, setBlogData] = useState<Blog[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const getBlogs = async () => {
      try {
        const blogs = await fetchBlogList();
        setBlogData(blogs);
      } catch (error) {
        console.error("Failed to fetch blogs", error);
      } finally {
        setLoading(false);
      }
    };
    getBlogs();
  }, []);

  return (
    <div
      // data-aos="fade-up"
      className="text-center pt-16 px-4 overflow-hidden bg-[#070b28] pb-24 mb-24"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundColor: "#070b28",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h2 className="text-[48px] font-oswald font-extrabold text-white">
        Blogs
      </h2>
      <img
        src={underlineimage}
        alt="underline"
        className="mx-auto mt-2 mb-6 w-[120px] h-auto"
      />

      {loading ? (
        <div className="flex justify-center items-center min-h-[200px]">
          <RoundLoader size={8} color="#f92c2c" borderWidth={5} />
        </div>
      ) : blogData.length === 0 ? (
        <p className="text-white">
          {t("blogs.noData", "No blog updates found.")}
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-center px-4 max-w-7xl mx-auto">
          {blogData.map((blog) => (
            <Suspense fallback={<div className="text-white">Loading...</div>} key={blog._id}>
              <BlogCard blog={blog} />
            </Suspense>
          ))}
        </div>
      )}
    </div>
  );
};

export default Blogs;
